export const getStartOfDay = (date: Date) => {
	const newDate = new Date(+date);
	newDate.setHours(0, 0, 0, 0);
	return newDate;
};
export const getEndOfDay = (date: Date) => {
	const twentyFourHours = 24 * 60 * 60 * 1000;
	return new Date(+getStartOfDay(date) + twentyFourHours);
};